import React from "react";
import { Link } from "react-router-dom";
const LeadershipJourney = () => {
const programs = [
  {
    title: "SYNERGIZE",
    image: "../../../cw/CW7.JPG",
    link: "/corporate-wellness/synergize",
  },
  {
    title: "RENEW",
    image: "../../../cw/CW8.JPG",
    link: "/corporate-wellness/renew",
  },
  {
    title: "INVISION",
    image: "../../../cw/CW6.JPG",
    link: "/corporate-wellness/invision",
  },
];

  return (
    <main className="bg-[#F7F1EA] min-h-screen">
      <section className="py-20 md:py-28 px-6">
        <div className="max-w-[1280px] mx-auto">

          {/* Label */}
          <div className="text-center mb-6">
            <div
              className="
                inline-flex
                items-center
                px-5
                py-2
                rounded-full
                bg-[#FFF4E8]
                border
                border-[#F3DDC7]
                text-primary
                text-[11px]
                tracking-[.18em]
                uppercase
                font-medium
              "
            >
              Leadership Development Journey
            </div>
          </div>

          {/* Heading */}
          <div className="max-w-5xl mx-auto text-center mb-16">
            <h1
              className="
                text-[clamp(40px,6vw,82px)]
                leading-[.95]
                tracking-[-0.05em]
                text-secondary
                mb-6
              "
            >
              A 3-Step Program
              <br />
              for Inner Empowerment
              <br />
              & Rejuvenation of Leaders
            </h1>

            <p
              className="
                text-[#5F5751]
                text-[17px]
                md:text-[18px]
                leading-9
                max-w-[760px]
                mx-auto
              "
            >
              An immersive leadership journey designed to help leaders
              recharge, cultivate inner clarity, strengthen emotional
              resilience, and lead with renewed purpose, presence, and vision.
            </p>
          </div>

          {/* Cards */}
{/* Cards */}
<div
  className="
    grid
    grid-cols-1
    md:grid-cols-2
    xl:grid-cols-3
    gap-8
    max-w-[1100px]
    mx-auto
  "
>
  {programs.map((program, index) => (
    <Link
      key={index}
      to={program.link}
      className="group block"
    >
      <div
        className="
          bg-white
          rounded-[32px]
          overflow-hidden
          shadow-[0_20px_60px_rgba(20,10,0,.08)]
          transition-all
          duration-500
          hover:-translate-y-2
          hover:shadow-[0_30px_70px_rgba(20,10,0,.12)]
        "
      >
        <div className="overflow-hidden">
          <img
            src={program.image}
            alt={program.title}
            className="
              w-full
              h-[340px]
              object-cover
              transition-transform
              duration-700
              group-hover:scale-105
            "
          />
        </div>

        <div className="px-8 py-8 text-center">
          <h2
            className="
              text-[30px]
              text-secondary
              tracking-[-0.03em]
            "
          >
            {program.title}
          </h2>
        </div>
      </div>
    </Link>
  ))}
</div>
        </div>
      </section>
    </main>
  );
};

export default LeadershipJourney;